(function () {
  if (customElements.get('poshaak-deferred-video')) return;

  customElements.define('poshaak-deferred-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.wantsAutoplay = this.video.autoplay || this.wantsAutoplay;
      this.video.autoplay = false;
      this.sources = Array.from(this.video.querySelectorAll('source[data-src]'));
      this.mediaQueries = this.sources.filter(source => source.media).map(source => matchMedia(source.media));
      this.mediaQueries.forEach(query => query.addEventListener('change', () => {
        if (this.loaded) this.load();
      }, options));

      this.video.addEventListener('canplay', () => this.play(), options);
      this.video.addEventListener('playing', () => this.classList.add('is-playing'), options);
      this.video.addEventListener('click', () => {
        if (this.video.controls) this.load();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.play();
      }, options);

      if ('IntersectionObserver' in window) {
        this.loadObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.load();
            this.loadObserver.disconnect();
          }
        }, { rootMargin: '200px 0px' });
        this.playObserver = new IntersectionObserver(entries => {
          this.inViewport = entries[0].isIntersecting;
          if (this.inViewport) {
            this.load();
            this.play();
          } else this.video.pause();
        }, { threshold: 0.01 });
        this.loadObserver.observe(this);
        this.playObserver.observe(this);
      } else {
        this.inViewport = true;
        this.load();
      }
    }

    load() {
      const source = this.sources.find(candidate =>
        (!candidate.media || matchMedia(candidate.media).matches) &&
        (!candidate.type || this.video.canPlayType(candidate.type))
      );
      if (!source) return;
      const url = source.dataset.src;
      if (this.currentSource === url) return;
      this.loaded = true;
      this.currentSource = url;
      this.classList.remove('is-playing');
      this.video.preload = 'metadata';
      this.video.src = url;
      this.video.load();
      this.play();
    }

    play() {
      if (!this.wantsAutoplay || !this.inViewport || document.hidden || !this.loaded) return;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      const playback = this.video.play();
      if (playback && playback.catch) playback.catch(() => {});
    }

    disconnectedCallback() {
      this.loadObserver?.disconnect();
      this.playObserver?.disconnect();
      this.controller?.abort();
      this.controller = null;
      this.video?.pause();
    }
  });
}());
